import { Injectable } from "@angular/core";
import { CHttp } from "../../core/services/chttp.service";
import { config } from "../../app.config";
import { Observable } from "rxjs";
import { MemberEvent } from "../members.interfaces";
import { Response } from "@angular/http";

@Injectable()
export class MemberService {
  constructor(private http: CHttp) { }

  public getMembers(data?: any) {
    return this.http.get(config.api_url + "members", {
      params: data,
    });
  }

  public getForVerification(data?: any) {
    return this.http.get(config.api_url + "members/for-verification", {
      params: data,
    });
  }

  public getVerificationCodes(data?: any) {
    return this.http.get(config.api_url + "members/verification-codes");
  }

  public getMember(id: string) {
    return this.http.get(config.api_url + "members/" + id);
  }

  public getMemberWebProfile(id: string) {
    return this.http.get(config.api_url + "members/" + id + "/web-profile");
  }

  public updateMember(data: any, id: string) {
    return this.http.put(`${config.api_url}members/${id}`, data);
  }

  public updateVipStatus(id: string, isVip: boolean) {
    return this.http.put(`${config.api_url}members/${id}/update-vip`, {
      isVip,
    });
  }

  public deleteMember(id: string, isGdpr: boolean) {
    return this.http.delete(`${config.api_url}members/${id}?isGdpr=${isGdpr}`);
  }

  public acceptMember(id: string) {
    return this.http.post(`${config.api_url}members/${id}/approve`);
  }

  public bulkAcceptMembers(userIds: string[]) {
    return this.http.post(`${config.api_url}members/approve/all`, { userIds });
  }

  public rejectMember(id: string) {
    return this.http.post(`${config.api_url}members/${id}/reject`);
  }

  public bulkRejectMembers(userIds: string[]) {
    return this.http.post(`${config.api_url}members/reject/all`, { userIds });
  }

  public exportUrl(query: string) {
    return this.http.get(config.api_url + "members/report" + query);
  }

  public requestNewId(id: string, type: string) {
    const body = { type };

    return this.http.post(
      `${config.api_url}members/${id}/request-new-proof-of-employment`,
      body,
    );
  }

  public bulkRequestNewIds(userIds: string[], type: string) {
    const body = {
      reason: { type },
      users: { userIds },
    };

    return this.http.post(
      `${config.api_url}members/request-new-proof-of-employment/all`,
      body,
    );
  }

  public suspendMember(id: string) {
    return this.http.post(`${config.api_url}members/${id}/suspend`);
  }

  public unsuspendMember(id: string) {
    return this.http.post(`${config.api_url}members/${id}/unsuspend`);
  }

  public forgottenPassword(email: string) {
    return this.http.post(`${config.api_url}members/forgotten-password`, {
      email: email,
    });
  }

  public cancelSubscriptionEndOfPeriod(userId: string) {
    return this.http.post(
      `${config.api_url}members/subscriptions/${userId}/cancel-end-of-period`,
    );
  }

  public cancelSubscriptionNow(userId: string) {
    return this.http.post(
      `${config.api_url}members/subscriptions/${userId}/cancel-now`,
    );
  }

  public bulkCancelSubscriptionsEndOfPeriod(userIds: string[]) {
    return this.http.post(
      `${config.api_url}members/subscriptions/cancel-end-of-period`,
      { userIds },
    );
  }

  public bulkCancelSubscriptionsNow(userIds: string[]) {
    return this.http.post(`${config.api_url}members/subscriptions/cancel-now`, {
      userIds,
    });
  }

  public bulkRemoveVIP(userIds: string[]) {
    return this.http.post(`${config.api_url}members/subscriptions/remove-vip`, {
      userIds,
    });
  }

  public addSubscription(id: string, data: any) {
    return this.http.post(
      `${config.api_url}members/subscriptions/${id}/system`,
      data,
    );
  }

  public getMemberStatuses() {
    return [
      {
        name: "All Statuses",
        value: "",
      },
      {
        name: "Waiting for verification",
        value: "WAITING_FOR_VERIFICATION",
      },
      {
        name: "Waiting for profile",
        value: "WAITING_FOR_PROFILE",
      },
      {
        name: "Waiting for payment",
        value: "WAITING_FOR_PAYMENT",
      },
      {
        name: "Waiting for proof",
        value: "WAITING_FOR_PROOF",
      },
      {
        name: "Waiting for Approval",
        value: "WAITING_FOR_APPROVAL",
      },
      {
        name: "Free Trial",
        value: "FREE_TRIAL",
      },
      {
        name: "Free Trial Ended",
        value: "FREE_TRIAL_ENDED",
      },
      {
        name: "Paid Member",
        value: "PAID_MEMBER",
      },
      {
        name: "Non-renewal",
        value: "NON_RENEWAL",
      },
      {
        name: "Free",
        value: "FREE",
      },
      {
        name: "VIP",
        value: "VIP",
      },
      {
        name: "Failed payment",
        value: "FAILED_PAYMENT",
      },
      {
        name: "Rejected",
        value: "REJECTED",
      },
      {
        name: "Suspended",
        value: "SUSPENDED",
      },
    ];
  }

  public getMemberRegistrationStatuses() {
    return [
      {
        name: "Waiting for validation",
        value: "WAITING_FOR_VALIDATION",
      },
      {
        name: "Waiting for personal information",
        value: "WAITING_FOR_PERSONAL_INFORMATION",
      },
      {
        name: "Waiting for payment information",
        value: "WAITING_FOR_PAYMENT_DETAILS",
      },
      {
        name: "Waiting for proof",
        value: "WAITING_FOR_PROOF_OF_EMPLOYMENT",
      },
    ];
  }

  public getMemberEvents(id: string): Observable<any> {
    return this.http.get(`${config.api_url}members/${id}/events`);
  }
}



// WEBPACK FOOTER //
// /Users/thxgg/Projects/Work/code-hospitality-cms/src/app/member/services/member.service.ts